var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#1A1A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03027 2.39844V5.05998L8.15979 6.06518L6.03027 2.39844Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03019 2.39844L3.90039 6.06518L6.03019 5.05998V2.39844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03027 7.79024V9.59871L8.16121 6.48438L6.03027 7.79024Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03019 9.59871V7.78994L3.90039 6.48438L6.03019 9.59871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03027 7.37327L8.15979 6.0671L6.03027 5.0625V7.37327Z",
    fill: "#1A1A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 6.0671L6.03019 7.37327V5.0625L3.90039 6.0671Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_32263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.943d8959e118e466eb5e84983ca69a36.svg";
export { ForwardRef as ReactComponent };